(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-napkin-option-guard]';
  const ready = (controls) => {
    const form = document.getElementById(controls.dataset.napkinOptionGuard);
    const button = controls.querySelector('[name="add"]');
    return Boolean(form && button && button.dataset.isRenderOptionSet === 'true' &&
      form.elements.namedItem('properties[Napkin Color]') &&
      form.elements.namedItem('properties[Foil Choice]'));
  };
  const sync = () => {
    document.querySelectorAll(selector).forEach((controls) => {
      const pending = !ready(controls);
      if (controls.inert !== pending) controls.inert = pending;
    });
  };
  document.addEventListener('click', (event) => {
    const controls = event.target.closest(selector);
    if (controls && !ready(controls)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const controls = event.target.querySelector(selector);
    if (controls && !ready(controls)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(sync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-is-render-option-set', 'form', 'name']
  });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
